import useAxiosRequestManager from 'common/axios-request-manager/AxiosRequestManager';
import { useCallback } from 'react';
import {
  BrokerLoggedInViewModel,
  mocked_BrokerLoggedInViewModel_Get
} from './brokerLoggedInViewModel';

export function useGetLoggedUserAsync(): () => Promise<BrokerLoggedInViewModel | null> {
  const { getAsync } = useAxiosRequestManager();

  return useCallback(async () => {
    try {
      const response = await getAsync(
        '/broker/logged-user',
        undefined,
        mocked_BrokerLoggedInViewModel_Get,
        undefined,
        false
      );

      return response.data!;
    } catch (err) {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
